import React, { useEffect, useMemo } from "react";
import get from 'lodash/get';
import { FETCH_OVERVIEW_ONLINE_REVIEW_BY_PROPERTIES_DATA_CAMPAIGN } from "../../../../actionTypes";
import { convertCstDataIntoTableCompatibleData, filterValuesFromArray } from "../../../../../../utils/transformChartsAndTableData";
import Table from "../../../../../../components/Common/Table";
import { useSelector } from "react-redux";
import { parseFilters } from "../../../../../Filters/utils/fetchData";
import useFetchOnlineReviewByPropertiesData from "../../../../hooks/useFetchOnlineReviewByPropertiesData";
import { View } from "../../../../../../components/Common/react-native-components";
import Pagination from "../../../../../../components/Common/Pagination";
import Loader from "./Loader";

const OnlineReviewTable = ({ lowSampleSize, setSelectedMetricOptions }) => {

    const { applied_filter_values, filtersLoading } = useSelector(e => e?.filterReducer);
    const filters = parseFilters(applied_filter_values);
    const updatedFilters = useMemo(() => {
        return {
            ...filters,
            filters: {
                ...filters.filters,
                additional_filters: {
                    ...filters.filters?.additional_filters,
                }
            }
        };
    }, [applied_filter_values]);

    const { data, data_per_page, onPageChange, isLoading, page, totalPages } = useFetchOnlineReviewByPropertiesData({
        campaign: FETCH_OVERVIEW_ONLINE_REVIEW_BY_PROPERTIES_DATA_CAMPAIGN,
        customFilters: updatedFilters,
        skip: filtersLoading || !filters?.benchmark
    });

    useEffect(() => {
        if (!isLoading && data) {
            let optionData = filterValuesFromArray(get(data, 'contents.columns', []), ["Rank", "Property", "# of records"])?.map(e => ({ label: e, value: e })) || []
            setSelectedMetricOptions(optionData)
        }
    }, [data, isLoading])

    const tableData = useMemo(() => {
        return convertCstDataIntoTableCompatibleData(get(data, 'contents') || {})
    }, [data])


    return (
        <View>
            {isLoading ? <Loader /> : <>
                <Table lowSampleSize={lowSampleSize} table_data={tableData} expendable={false} />
            </>}
            <Pagination
                onPageChange={onPageChange}
                currentPage={page}
                pageSize={data_per_page}
                totalRecords={totalPages}
            />
        </View>
    );
}

export default OnlineReviewTable;